import { z } from 'zod';
/** Route params for the endpoints addressing a single scenario. */
export const ScenarioIdParamsSchema = z.object({ scenarioId: z.uuid() }).strict();
//# sourceMappingURL=params.js.map